import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { Button } from './ui/button';
import SectionLabel from './SectionLabel';
import { CTA_URL } from '../mock';
import { useI18n } from '../i18n/I18nContext';

export default function AboutIntro() {
  const { t } = useI18n();
  return (
    <section id="rolunk" className="relative py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5">
        <div className="relative rounded-[28px] border border-blue-500/12 bg-gradient-to-br from-blue-50 via-white to-white p-8 md:p-16 overflow-hidden">
          <div className="absolute -top-40 -left-40 h-96 w-96 rounded-full bg-blue-500/10 blur-[100px]" />
          <div className="absolute -bottom-40 -right-40 h-96 w-96 rounded-full bg-sky-500/10 blur-[100px]" />
          <div className="relative grid lg:grid-cols-12 gap-10">
            <div className="lg:col-span-5 space-y-5">
              <SectionLabel>{t('about_intro.tag')}</SectionLabel>
              <div className="font-mono text-[10px] tracking-[0.4em] text-blue-600">LEADEVEREST</div>
              <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-semibold text-slate-900 leading-[1.05]">
                {t('about_intro.title_a')} <span className="text-gradient-green">{t('about_intro.title_b')}</span>
              </h2>
            </div>
            <div className="lg:col-span-7 space-y-5 text-slate-700 text-[15px] md:text-base leading-relaxed">
              <p>{t('about_intro.p1')}</p>
              <p>{t('about_intro.p2')}</p>
              <p>{t('about_intro.p3')}</p>
              <p>{t('about_intro.p4')}</p>
              <div className="flex flex-wrap gap-3 pt-4">
                <a href={CTA_URL} target="_blank" rel="noreferrer">
                  <Button className="btn-primary bg-blue-500 hover:bg-blue-600 text-white font-medium rounded-xl h-11 px-5">
                    {t('common.free_consultation')}<ArrowUpRight className="ml-1.5 h-4 w-4" />
                  </Button>
                </a>
                <a href="#kapcsolat">
                  <Button variant="outline" className="rounded-xl h-11 px-5 bg-transparent border-blue-500/25 text-slate-700 hover:bg-blue-500/10 hover:text-slate-900 hover:border-blue-500/50">
                    {t('common.contact')}
                  </Button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
